// src/components/ProgressStepper.tsx

import React from 'react';
import { styled } from '../../styles/stitches.config'; // Adjust path to your stitches config

// --- Styled Components for the Stepper ---

const StepperContainer = styled('div', {
  display: 'flex',
//   alignItems: 'center',
  justifyContent: 'flex-start',
  flexWrap: 'wrap', // Allows steps to wrap on smaller screens
  gap: '0.5rem',
  padding: '1rem 0',
  width: '100%',
//   top: '20rem'
});

const StepItem = styled('span', {
  fontSize: '$sm',
  transition: 'color 0.2s ease',

  // Define variants for different states
  variants: {
    state: {
      active: {
        color: '', // Color for the current step
        fontWeight: '$bold',
      },
      completed: {
        color: '$elementBorder', // Color for steps already passed
      },
      upcoming: {
        color: '$elementBorder', // Color for future steps
      },
    },
  },
});

const Separator = styled('span', {
  color: '$elementBorder',
  margin: '0 0.25rem',
});

// --- The Component Itself ---

interface ProgressStepperProps {
  steps: string[];
  currentStep: number;
}

export const ProgressStepper: React.FC<ProgressStepperProps> = ({ steps, currentStep }) => {
  return (
    <StepperContainer>
      {steps.map((stepName, index) => {
        // Determine the state of the current step in the loop
        const state =
          index === currentStep
            ? 'active'
            : index < currentStep
            ? 'completed'
            : 'upcoming';

        return (
          <React.Fragment key={stepName}>
            <StepItem state={state}>{stepName}</StepItem>
            {/* Don't show the separator after the last item */}
            {index < steps.length - 1 && <Separator>&gt;</Separator>}
          </React.Fragment>
        );
      })}
    </StepperContainer>
  );
};